<div class="install-bar" *ngIf="!dismissed && deferredPrompt">
  <div class="install-bar-content">
    <button class="btn btn-primary mx-auto" (click)="prompt()">Get the {{ (account$ | async)?.name }} app</button>
    <button class="close" aria-label="Close" (click)="dismissed = true">
      <svg-icon src="assets/icons/material-design-icons/close/sharp.svg"></svg-icon>
    </button>
  </div>
</div>
